import './datalayer';
import './common';
import './components/lightbox';

$(document).ready(function(){

  // ----------------------------
  //  Removal of empty .ai-content divs
  // ----------------------------
  $('.ai-content:empty').remove();

// ----------------------------
// wrapping the table press tables
// ----------------------------
  if($('.post__content table').length ) {
    $('.post__content table').wrap('<div class="table-responsive"></div>');
  }

  // ----------------------------
  // make apester iframes responsive
  // ----------------------------
  $('iframe[src*="qmerce"]').attr('width', '100%');

  // ----------------------------
  // sticky sidebar
  // ----------------------------
  // $('#sticky-sidebar').stick_in_parent({
  //   parent: '.container',
  //   offset_top: 40
  // });

  //BTN SHARE LINK
  $('.btn-share-link').on('click', function(e) {
    e.preventDefault();
    var copyText = $(this).attr('data-copy');
    navigator.clipboard.writeText(copyText);

    // Alert the copied text
    var link = $(this);
    link.addClass('copied');
    setTimeout(function() {
      link.removeClass('copied');
    }, 1000);
  });


  // ----------------------------
  // AD for single posts
  // ----------------------------

  $('body.single-post .post__content').each(function(){
    var t_number = $('h2', this).length;
    if (t_number >= 3) {
      $('.post__content > h2:nth-of-type(3)').before('<div id="imoney_res_mid2"></div>')
    }
  });
})
